import { PayloadAction } from '@reduxjs/toolkit';
import { createApiCredentials, editApiCredentials } from './form.thunks';
import { ApiCredentialsFormState } from './apiCredentialsFormState';

export const extraReducers = {
  [createApiCredentials?.pending.type]: (state: ApiCredentialsFormState): void => {
    state.loading = true;
    state.error = null;
  },
  [createApiCredentials?.fulfilled.type]: (state: ApiCredentialsFormState): void => {
    state.loading = false;
  },
  [createApiCredentials?.rejected.type]: (state: ApiCredentialsFormState, action: PayloadAction<string>): void => {
    state.loading = false;
    state.error = action.payload;
  },
  [editApiCredentials?.pending.type]: (state: ApiCredentialsFormState): void => {
    state.loading = true;
    state.error = null;
  },
  [editApiCredentials?.fulfilled.type]: (state: ApiCredentialsFormState): void => {
    state.loading = false;
  },
  [editApiCredentials?.rejected.type]: (state: ApiCredentialsFormState, action: PayloadAction<string>): void => {
    state.loading = false;
    state.error = action.payload;
  }
};

export default extraReducers;